import React from 'react';
import { motion } from 'motion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faIndianRupeeSign,
  faUsers,
  faPalette,
  faGavel,
} from '@fortawesome/free-solid-svg-icons';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import useCountUp from '../../hooks/useCountUp';
import { revealStagger } from '../../utils/motion';

const STATS_CONFIG = [
  { icon: faIndianRupeeSign, end: 12, prefix: '₹', suffix: 'Cr+', label: 'Art Value Listed', duration: 2000, growth: '+28% Q/Q' },
  { icon: faUsers, end: 1200, suffix: '+', label: 'Active Investors', duration: 2200, growth: 'Verified KYC' },
  { icon: faPalette, end: 320, suffix: '+', label: 'Artists Onboarded', duration: 1800, growth: 'Curated' },
  { icon: faGavel, end: 85, suffix: '+', label: 'Auctions Completed', duration: 1600, growth: '100% Cleared' },
];

function StatCard({ config, isVisible, index = 0 }) {
  const { display } = useCountUp(config.end, config.duration, isVisible, config.prefix || '', config.suffix || '');
  const cardTheme = index === 1 ? 'lp-card-dark' : 'lp-card-light';

  return (
    <motion.div
      className={`lp-stat-card ${cardTheme}`}
      variants={revealStagger.item}
      whileHover={{ y: -6, scale: 1.02, transition: { duration: 0.25 } }}
    >
      <div className="lp-stat-top">
        <div className="lp-stat-icon">
          <FontAwesomeIcon icon={config.icon} />
        </div>
        <span className="lp-stat-growth-tag">{config.growth}</span>
      </div>
      <div className="lp-stat-value tabular-nums font-mono">{display}</div>
      <div className="lp-stat-label">{config.label}</div>
    </motion.div>
  );
}

export default function StatsSection() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.2 });

  return (
    <section className="lp-stats" ref={ref}>
      <div className="lp-container lp-stats-content">
        <div className="lp-section-header">
          <span className="lp-section-badge">Platform Metrics</span>
          <h2 className="lp-section-title">
            Numbers That <span className="lp-gradient-text">Speak</span>
          </h2>
          <p className="lp-section-desc">
            Our growing community of artists and investors is reshaping
            how fine art value is unlocked, distributed, and compounded.
          </p>
        </div>

        <motion.div
          className="lp-stats-grid"
          variants={revealStagger.container}
          initial="hidden"
          animate={isVisible ? 'visible' : 'hidden'}
        >
          {STATS_CONFIG.map((stat, i) => (
            <StatCard key={i} config={stat} isVisible={isVisible} index={i} />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
